import { Tooltip, type TooltipProps } from 'antd';

export function ToolbarTooltip(props: TooltipProps) {
  return (
    <Tooltip
      {...props}
      arrow={false}
      align={{ offset: [0, -4] }}
      overlayInnerStyle={{
        fontSize: 'var(--font-size-sm)',
        padding: '2px 8px',
        minHeight: 'auto',
      }}
    />
  );
}
